import React, {useEffect} from 'react';
import {Show, useGetList, useRecordContext, useRedirect, useTranslate} from 'react-admin';
import {Box, Typography} from '@mui/material';
import {t} from '../themes/statamicTokens';
import PageHeader from '../components/statamic/PageHeader';
import StatusDot from '../components/statamic/StatusDot';
import UmbrellaNotificationsCard from './UmbrellaNotificationsCard';

/**
 * The umbrella admin's own umbrella (OUTCOME item 10): the name and the Notifications card only.
 * The rest of the umbrella record stays with the Nofam admin, so nothing else is shown here.
 */

/** List route: the umbrellad list holds exactly the caller's own umbrella, so open it. */
export const UmbrellaOwnList = () => {
    const redirect = useRedirect();
    const translate = useTranslate();
    const {data, isPending} = useGetList('umbrellas', {
        pagination: {page: 1, perPage: 1},
        sort: {field: 'charity_name', order: 'ASC'},
    });
    const ownId = data?.[0]?.id;

    useEffect(() => {
        if (ownId) redirect('show', 'umbrellas', ownId);
    }, [ownId, redirect]);

    if (isPending || ownId) return null;
    return (
        <Typography sx={{p: 3, color: t.color.text.muted, fontSize: `${t.type.small.size}px`}}>
            {translate('ra.navigation.no_results')}
        </Typography>
    );
};

const UmbrellaOwnContent = () => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <Box sx={{backgroundColor: t.color.page, minHeight: '100%'}}>
            <PageHeader
                title={
                    <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', gap: 1}}>
                        <StatusDot variant={record.active ? 'success' : 'neutral'}/>
                        <Box component="span">{record.charity_name}</Box>
                    </Box>
                }
            />
            <Box sx={{p: 3, maxWidth: 640}}>
                <UmbrellaNotificationsCard record={record}/>
            </Box>
        </Box>
    );
};

export const UmbrellaOwnShow = (props) => (
    <Show {...props} actions={false} component={Box} sx={{backgroundColor: t.color.page}}>
        <UmbrellaOwnContent/>
    </Show>
);
